const initialState = {
  favorites: [],
  loading: false,
  error: null,
};

const favoriteReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "GET_FAVORITES":
      return { ...state, favorites: payload };
    case "ADD_FAVORITE":
      return { ...state, favorites: [...state.favorites, payload] };
    case "REMOVE_FAVORITE":
      return {
        ...state,
        favorites: state.favorites.filter((f) => f.id !== payload),
      };
    case "RESET_FAVORITES":
      return initialState;
    default:
      return state;
  }
};

export default favoriteReducer;
